var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubAgrupar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5596_18558",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 16,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.73341 9.09234L1.06675 5.75521C0.800081 5.62173 0.666748 5.4215 0.666748 5.15453C0.666748 4.88756 0.800081 4.68733 1.00008 4.55385L7.66675 1.21672C7.86675 1.14998 8.06675 1.14998 8.26675 1.21672L14.9334 4.55385C15.2001 4.68733 15.3334 4.88756 15.3334 5.15453C15.3334 5.4215 15.2001 5.62173 14.9334 5.75521L8.26675 9.09234C8.20008 9.15908 8.13341 9.15908 8.00008 9.15908C7.86675 9.15908 7.80008 9.15908 7.73341 9.09234ZM13.2001 5.15453L8.00008 2.55157L2.80008 5.15453L8.00008 7.75749L13.2001 5.15453ZM15.2667 11.5618C15.4001 11.8955 15.2667 12.296 15.0001 12.4295L8.33341 15.7666C8.20008 15.8333 8.13341 15.8333 8.00008 15.8333C7.86675 15.8333 7.80008 15.8333 7.73341 15.7666L1.06675 12.4295C0.733415 12.296 0.600081 11.8955 0.800081 11.5618C0.933415 11.2281 1.33341 11.0946 1.66675 11.2948L8.06675 14.4985L14.4667 11.2948C14.6667 11.0946 15.0667 11.2281 15.2667 11.5618ZM15.0001 9.09234C15.2667 8.95885 15.4001 8.5584 15.2667 8.22469C15.0667 7.89097 14.6667 7.75749 14.4667 7.95772L8.06675 11.1614L1.66675 7.95772C1.33341 7.75749 0.933415 7.89097 0.800081 8.22469C0.600081 8.5584 0.733415 8.95885 1.06675 9.09234L7.73341 12.4295C7.80008 12.4962 7.86675 12.4962 8.00008 12.4962C8.13341 12.4962 8.20008 12.4962 8.33341 12.4295L15.0001 9.09234Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5596_18558)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#4B4B4B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubAgrupar);
export default __webpack_public_path__ + "static/media/Sub-agrupar.6c6d683e91b2bbbfe8ea8117e11114d0.svg";
export { ForwardRef as ReactComponent };